<template>
  <div><small class="has-text-grey">
    <b-icon size="is-small mr-1" type="is-primary" icon="retweet"></b-icon>
    <span>Retweeted by</span>
    <link-to-profile :screen-name="user.screen_name" class="has-text-grey">
      {{ user.name }} (@{{ user.screen_name }})
    </link-to-profile>
    <link-to-tweet class="has-text-grey" :id="data.id" :screen_name="user.screen_name" >{{ retweetedDistance }} later</link-to-tweet>
  </small></div>
</template>

<script>

import { parseISO, formatDistance } from 'date-fns'
import LinkToProfile from "../controls/LinkToProfile";
import LinkToTweet from "../controls/LinkToTweet";

export default {
  name: "TweetRetweeted",
  components: {LinkToTweet, LinkToProfile},
  props: ['data'],
  computed: {
    user() {
      return this.data.retweeted_by
    },
    retweetedDistance() {
      let d1 = parseISO(this.data.retweeted_at)
      let d2 = parseISO(this.data.created_at)
      return formatDistance(d1, d2, {includeSeconds: true})
    }
  }
}
</script>

<style scoped>

</style>
